<template>
    <transition name="fade">
        <div class="patient-coaching-summary-logs">

            <b-row>
                <b-col cols="1"></b-col>
                <b-col cols="5">
                    <participant-metrics-chart-time-series
                        :metrics="participant.metrics"
                        metric="ACTIVITY"
                        :highlight-start="participant.last_rpm_check_date">
                    </participant-metrics-chart-time-series>
                    <label class="ml-3">{{ $i18n.gt('LABEL_COACHING_STEPS') }}</label>
                </b-col>
                <b-col cols="5">
                    <participant-metrics-chart-time-series
                        :metrics="participant.metrics"
                        metric="WEIGHT"
                        :highlight-start="participant.last_rpm_check_date">
                    </participant-metrics-chart-time-series>
                    <label class="ml-3">{{ $i18n.gt('LABEL_COACHING_WEIGHT') }}</label>
                </b-col>
                <b-col cols="1"></b-col>
            </b-row>

        </div>
    </transition>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>

import Vue from 'vue'

export default Vue.extend({
    name: 'PatientCoachingSummaryLogs',
    computed: {
        participant () {
            return this.$store.state.patientParticipant
        },
    }
})
</script>
